import React, { useState } from 'react';
import { Modal } from './Modal';
import './InterruptModal.css';

interface InterruptModalProps {
  isOpen: boolean;
  escPressCount: number;
  onConfirm: (reason?: string) => void;
  onCancel: () => void;
}

const InterruptModal: React.FC<InterruptModalProps> = ({
  isOpen,
  escPressCount,
  onConfirm,
  onCancel
}) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason || undefined);
    setReason('');
  };

  const handleCancel = () => {
    onCancel();
    setReason('');
  };

  if (!isOpen) return null;
  
  return (
    <Modal
      title="Interrupt Workflow"
      onClose={handleCancel}
      className="interrupt-modal"
    >
      <div className="interrupt-modal-content">
        <div className="interrupt-modal-icon">
          ⚠️
        </div>
        
        <h3 className="interrupt-modal-title">
          Interrupt Workflow?
        </h3>
        
        <p className="interrupt-modal-message">
          {escPressCount === 1 
            ? 'Press ESC again to stop the workflow, or click Continue to resume.'
            : 'Are you sure you want to interrupt the workflow?'}
        </p>
        
        <p className="interrupt-modal-info">
          Current progress will be saved and you can resume later.
        </p>
        
        <div className="interrupt-modal-reason">
          <input
            type="text"
            placeholder="Reason for interruption (optional)"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="interrupt-reason-input"
            autoFocus
          />
        </div>
        
        <div className="interrupt-modal-actions">
          <button
            className="interrupt-btn interrupt-btn-danger"
            onClick={handleConfirm}
            title="Press ESC again to confirm"
          >
            Stop Workflow {escPressCount === 1 && '(ESC)'}
          </button>
          <button
            className="interrupt-btn interrupt-btn-secondary"
            onClick={handleCancel}
          >
            Continue
          </button>
        </div>

        {escPressCount === 1 && (
          <div className="interrupt-modal-hint">
            Press ESC again to confirm interruption
          </div>
        )}
      </div>
    </Modal>
  );
};

export default InterruptModal;